import { render, staticRenderFns } from "./AddWMSWarehouse.vue?vue&type=template&id=3c6d1486&scoped=true"
import script from "./AddWMSWarehouse.vue?vue&type=script&lang=js"
export * from "./AddWMSWarehouse.vue?vue&type=script&lang=js"
import style0 from "./AddWMSWarehouse.vue?vue&type=style&index=0&id=3c6d1486&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6d1486",
  null
  
)

export default component.exports